import {
  FETCH_CLIENT,
  SET_CLIENT,
  FETCH_HOME_SUMMARY,
  FETCH_POI_COUNT,
  FETCH_HOME_ORGANISATIONS,
  FETCH_PROSPECTS_TO_WATCH_DATA,
  SET_HOME_DATE_RANGE,
  SET_HOME_DATE_RANGE_ALL_TIME,
  FETCH_WHERE_YOUR_CUSTOMERS_HAVE_BEEN,
  SET_HOME_DATE_RANGE_PRESET,
  FETCH_BIGGEST_MOVERS,
} from '../constants';

export const fetchClient = () => ({
  type: FETCH_CLIENT,
});

export const setClient = () => ({
  type: SET_CLIENT,
});

export const setHomeDateRange = (sinceDate, untilDate, prevSinceDate, prevUntilDate) => ({
  type: SET_HOME_DATE_RANGE,
  sinceDate,
  untilDate,
  prevSinceDate,
  prevUntilDate
});

export const setDateRangePreset = dateRangePreset => ({
  type: SET_HOME_DATE_RANGE_PRESET,
  dateRangePreset,
});

export const setHomeDateRangeAllTime = (sinceDate, untilDate) => ({
  type: SET_HOME_DATE_RANGE_ALL_TIME,
  sinceDate,
  untilDate
});

export const fetchHomeSummary = () => ({
  type: FETCH_HOME_SUMMARY,
});

export const fetchPoiCount = () => ({
  type: FETCH_POI_COUNT,
});


export const fetchHomeOrganisations = () => ({
  type: FETCH_HOME_ORGANISATIONS,
});

export const fetchProspectsToWatch = () => ({
  type: FETCH_PROSPECTS_TO_WATCH_DATA,
});

export const fetchWhereYourCustomersHaveBeen = () => ({
  type: FETCH_WHERE_YOUR_CUSTOMERS_HAVE_BEEN,
});

export const fetchBiggestMovers = () => ({
  type: FETCH_BIGGEST_MOVERS,
});



